import React from 'react';
import { Ssvg } from '../../../Components/react/Ssvg';
export const BackToTopButton = () => {
    return (React.createElement("div", { className: "text:center" },
        React.createElement("button", { className: "btn:cleared d:inline-flex ai:center pb:32", onClick: () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, "aria-hidden": true },
            "Back to top ",
            React.createElement(Ssvg, { icon: "icon--arrow-up", className: "h:6 mb:-2 ml:6" }))));
};
